module.exports = __webpack_public_path__ + "static/media/internet.ef66a406.png";